import React, { useMemo } from 'react'
import styled from 'styled-components'
import Panel from '../Panel'
import { AutoColumn } from '../Column'
import { RowFixed } from '../Row'
import { TYPE } from '../../Theme'
import { usePairData } from '../../contexts/PairData'
import { formattedNum } from '../../utils'
import { AIC_USDI_PAIR } from '../../constants'

const PriceCard = styled(Panel)`
  position: absolute;
  right: -220px;
  width: 220px;
  top: -20px;
  z-index: 9999;
  height: fit-content;
  background-color: ${({ theme }) => theme.bg1};
`

export default function UniPrice() {
  const aicUsdiPair = usePairData(AIC_USDI_PAIR)

  const priceAICInUSDI = useMemo(() => {
    if (!aicUsdiPair) return '-'
    const p0 = Number(aicUsdiPair.token0Price)
    const p1 = Number(aicUsdiPair.token1Price)
    if (isFinite(p0) && isFinite(p1)) {
      return (p0 > p1 ? p0 : p1).toFixed(4)
    }
    return '-'
  }, [aicUsdiPair])

  return (
    <PriceCard>
      <AutoColumn gap="10px">
        <RowFixed>
          <TYPE.main>AIC/USDI: {formattedNum(priceAICInUSDI, true)}</TYPE.main>
        </RowFixed>
      </AutoColumn>
    </PriceCard>
  )
}
